<div class="relative flex items-start">
  <div class="flex-1 min-w-0 flex flex-col gap-2xl">
    @for (view of sectionViews(); track view.section.id; let i = $index) {
      @let section = view.section;
      <section class="rounded-xl bg-primary-50 p-lg space-y-lg">
        <div class="flex items-center gap-sm">
          @if (renamingId() === section.id) {
            <div class="flex flex-1 items-end gap-sm" [formGroup]="renameForm">
              <div class="flex-1">
                <div formGroupName="label">
                  <lib-dual-lang-input
                    [requiredGroup]="true"
                    [inputFormControlName]="'label'"
                    [id]="'custom_workflow_section_' + section.id"
                    type="text"
                    name="label"
                    [requiredEn]="false"
                    [requiredAr]="false"
                    [label]="'custom_workflow_section_title_label' | transloco"
                    [placeholderEn]="
                      'custom_workflow_field_label_en' | transloco
                    "
                    [placeholderAr]="
                      'custom_workflow_field_label_ar' | transloco
                    " />
                </div>
                <lib-validation-message
                  [lang]="'current_lang' | transloco"
                  control="label" />
              </div>
              <button
                type="button"
                class="inline-flex items-center justify-center rounded-md border border-primary-200 bg-primary-50 px-3 py-1.5 text-xs font-medium text-primary-700 transition-colors hover:bg-primary-100"
                [id]="'custom_workflow_section_save_' + section.id"
                (click)="saveRename()">
                {{ 'custom_workflow_save_button' | transloco }}
              </button>
              <button
                type="button"
                class="inline-flex items-center justify-center rounded-md border border-neutral-200 px-3 py-1.5 text-xs font-medium text-neutral-500 transition-colors hover:bg-neutral-100"
                (click)="renamingId.set(null)">
                {{ 'custom_workflow_cancel_button' | transloco }}
              </button>
            </div>
          } @else {
            <div class="flex items-center gap-1 shrink-0">
              @if (view.canMoveUp && !readonly()) {
                <button
                  type="button"
                  class="inline-flex h-7 w-7 items-center justify-center rounded-md border border-transparent text-neutral-400 transition-colors hover:border-neutral-200 hover:bg-neutral-100 hover:text-neutral-600"
                  [id]="'custom_workflow_move_section_up_' + section.id"
                  [attr.aria-label]="
                    'custom_workflow_move_section_up' | transloco
                  "
                  (click)="moveSection(i, -1)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true">
                    <path d="m18 15-6-6-6 6" />
                  </svg>
                </button>
              }
              @if (view.canMoveDown && !readonly()) {
                <button
                  type="button"
                  class="inline-flex h-7 w-7 items-center justify-center rounded-md border border-transparent text-neutral-400 transition-colors hover:border-neutral-200 hover:bg-neutral-100 hover:text-neutral-600"
                  [id]="'custom_workflow_move_section_down_' + section.id"
                  [attr.aria-label]="
                    'custom_workflow_move_section_down' | transloco
                  "
                  (click)="moveSection(i, 1)">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="14"
                    height="14"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true">
                    <path d="m6 9 6 6 6-6" />
                  </svg>
                </button>
              }
            </div>

            @if (!readonly()) {
              <button
                type="button"
                class="flex-1 text-start font-semibold text-neutral-900 transition-colors hover:text-primary-600"
                [id]="'custom_workflow_section_rename_' + section.id"
                (click)="startRename(section)">
                {{ view.title }}
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  class="ms-1 inline-block opacity-40"
                  aria-hidden="true">
                  <path
                    d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z" />
                  <path d="m15 5 4 4" />
                </svg>
              </button>
            } @else {
              <span class="flex-1 text-start font-semibold text-neutral-900">
                {{ view.title }}
              </span>
            }

            <div class="flex items-center gap-1 shrink-0">
              @if (view.actions.length) {
                <lib-action-list
                  [menuItems]="view.actions"
                  (itemClick)="onSectionAction($event, section)" />
              }
            </div>
          }
        </div>

        <div
          cdkDropList
          cdkDropListOrientation="mixed"
          [cdkDropListDisabled]="readonly()"
          (cdkDropListDropped)="dropField(section, $event)"
          class="grid [grid-template-columns:repeat(auto-fill,minmax(20rem,1fr))] gap-lg items-start">
          @for (item of view.fields; track item.field.id) {
            @let field = item.field;
            <div
              cdkDrag
              [cdkDragDisabled]="readonly() || reorderingFieldId() !== null"
              class="group relative min-w-0 rounded-lg border border-primary-100 bg-white p-md transition-shadow cursor-grab active:cursor-grabbing hover:border-primary-300 hover:shadow-sm"
              [class.opacity-50]="reorderingFieldId() === field.id"
              [class]="{
                'col-span-full':
                  field.type === inputTypesEnum.LOOKUP ||
                  field.type === inputTypesEnum.GROUP_INPUT_FIELD ||
                  field.type === inputTypesEnum.TABLE_INPUT_FIELD,
                'col-span-2':
                  field.type ===
                    inputTypesEnum.RICH_EDITOR_DUAL_LANGUAGE_TEXT_AREA_FIELD ||
                  field.type === inputTypesEnum.DUAL_LANGUAGE_TEXT_AREA_FIELD ||
                  field.type === inputTypesEnum.TEXT_INPUT_FIELD,
              }">
              <div class="mb-sm flex min-w-0 items-center gap-sm">
                <span
                  class="touch-none text-neutral-400 group-hover:text-neutral-600"
                  aria-hidden="true">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 24 24"
                    fill="none"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    aria-hidden="true">
                    <circle cx="9" cy="12" r="1" />
                    <circle cx="9" cy="5" r="1" />
                    <circle cx="9" cy="19" r="1" />
                    <circle cx="15" cy="12" r="1" />
                    <circle cx="15" cy="5" r="1" />
                    <circle cx="15" cy="19" r="1" />
                  </svg>
                </span>

                @if (field.metadata.mandatory) {
                  <lib-badge
                    [label]="'custom_workflow_required_badge' | transloco"
                    badgeClass="!rounded-2xl bg-destructive-50 border-destructive-200 px-sm text-xs2 font-semibold text-destructive-500" />
                }

                <lib-badge
                  [label]="item.typeLabel"
                  badgeClass="!rounded-2xl bg-neutral-50 border-neutral-200 px-sm text-xs2 font-semibold text-neutral-500" />

                <div class="absolute top-1.5 end-1.5 z-20">
                  <lib-action-list
                    [menuItems]="item.actions"
                    (itemClick)="onFieldAction($event, field)" />
                </div>
              </div>

              <lib-form-builder-field-static-preview
                [fieldType]="field.type"
                [fieldLabel]="item.title"
                [isRequired]="field.metadata.mandatory"
                [placeholder]="item.placeholder"
                [hint]="item.hint"
                [options]="field.metadata.options" />
            </div>
          } @empty {
            <div
              class="col-span-6 rounded-lg border border-dashed border-neutral-200 py-xl text-center text-sm text-neutral-400">
              {{ 'custom_workflow_section_empty' | transloco }}
            </div>
          }
        </div>

        @if (!workflow().locked && !readonly()) {
          <button
            type="button"
            class="inline-flex w-full items-center justify-center gap-1.5 rounded-md border border-neutral-200 px-3 py-2 text-xs font-medium text-neutral-500 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
            [id]="'custom_workflow_add_field_' + section.id"
            (click)="startNewField(section.id)">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
              aria-hidden="true">
              <path d="M5 12h14" />
              <path d="M12 5v14" />
            </svg>
            {{ 'custom_workflow_add_field_button' | transloco }}
          </button>
        }
      </section>
    }

    @if (!workflow().locked && !readonly()) {
      <button
        type="button"
        id="custom_workflow_add_section"
        class="inline-flex items-center gap-1.5 self-start rounded-md border border-neutral-200 px-3 py-2 text-xs font-medium text-neutral-500 transition-colors hover:border-primary-300 hover:bg-primary-50 hover:text-primary-700"
        (click)="addSection()">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
          stroke-linecap="round"
          stroke-linejoin="round"
          aria-hidden="true">
          <path d="M5 12h14" />
          <path d="M12 5v14" />
        </svg>
        {{ 'custom_workflow_add_section_button' | transloco }}
      </button>
    }
  </div>

  <!-- Inline field panel (slides in from right) -->
  <div
    class="flex-shrink-0 bg-white border-s border-neutral-200 flex flex-col overflow-hidden transition-[width] duration-[220ms]"
    [class.w-160]="editing() !== null"
    [class.w-0]="editing() === null">
    @if (editing(); as e) {
      <div class="w-160 flex flex-col h-[calc(100vh)]">
        <header
          class="flex items-center justify-between px-lg py-lg border-b border-neutral-200 flex-shrink-0">
          <h2 class="text-sm font-semibold text-neutral-900">
            {{ editorTitle() }}
          </h2>
          <button
            type="button"
            id="custom_workflow_field_drawer_close"
            class="flex items-center justify-center size-3xl rounded border-none bg-transparent cursor-pointer text-neutral-500 hover:bg-neutral-100 transition-colors"
            aria-label="close"
            (click)="requestClose()">
            ✕
          </button>
        </header>
        <div class="flex-1 overflow-y-auto px-lg">
          <lib-custom-workflow-field-editor
            [workflow]="workflow()"
            [sectionId]="e.sectionId"
            [field]="e.field"
            [options]="fieldOptions()"
            [readonly]="readonly()"
            (saved)="onFieldSaved()"
            (cancelled)="editing.set(null)"
            (apiError)="apiError.emit($event)" />
        </div>
      </div>
    }
  </div>
</div>

<ng-template #discard>
  <div class="text-center font-medium text-lg text-neutral-900 mb-sm">
    {{ 'discard_modal_title' | transloco }}
  </div>
  <div class="text-center text-sm text-neutral-500">
    {{ 'discard_modal_description' | transloco }}
  </div>
  <div class="flex flex-col gap-md mt-4xl">
    <button
      id="custom_workflow_field_keep_editing"
      class="px-2xl py-sm rounded-md text-white bg-primary-500 text-lg font-medium border-none cursor-pointer"
      (click)="keepEditing()">
      {{ 'custom_workflow_keep_editing_button' | transloco }}
    </button>
    <button
      id="custom_workflow_field_discard"
      class="px-2xl py-sm rounded-md text-neutral-700 bg-white text-lg font-medium border border-neutral-300 cursor-pointer"
      (click)="discardAndClose()">
      {{ 'discard_modal_discard_button' | transloco }}
    </button>
  </div>
</ng-template>
